import React from "react";
export const AppLoading = () => <div className="loadingContainer"><div className="lds-ellipsis">
<div></div><div></div><div></div><div></div>
</div></div>;
